export default "__VITE_ASSET__BpxD57TH__"